import React from 'react';
import classNames from 'classnames';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  trend?: {
    value: number;
    label: string;
    isPositive?: boolean;
  };
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  className,
}) => {
  return (
    <div className={classNames('bg-gray-800 rounded-lg border border-gray-700 p-6', className)}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-400">{title}</p>
          <p className="mt-2 text-3xl font-semibold text-white">{value}</p>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
          )}
          {trend && (
            <p className={classNames(
              'mt-2 text-sm flex items-center',
              trend.isPositive ? 'text-green-400' : 'text-red-400'
            )}>
              <span className="font-medium">
                {trend.isPositive ? '+' : ''}{trend.value}
              </span>
              <span className="ml-1 text-gray-500">{trend.label}</span>
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-3 bg-gray-700 rounded-lg">
            <Icon className="w-6 h-6 text-primary-400" />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
